/**
 * Base API Client
 * Provides shared functionality for all API endpoints
 */

import { getIDToken } from "../../services/firebase";
import { getSelectedWorkspace } from "../../services/workspace";
import { agentPlatformConfig } from "../config";

export class BaseApiClient {
  protected baseUrl: string;

  constructor() {
    this.baseUrl = agentPlatformConfig.apiUrl;
  }

  protected async getHeaders(): Promise<HeadersInit> {
    const token = await getIDToken();
    const workspace = getSelectedWorkspace();

    const headers: HeadersInit = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    };

    if (workspace) {
      headers["x-introist-workspace"] = workspace;
    }

    return headers;
  }

  protected async request<T>(path: string, options: RequestInit = {}): Promise<T> {
    const headers = await this.getHeaders();
    const url = `${this.baseUrl}${path}`;

    const response = await fetch(url, {
      ...options,
      headers: {
        ...headers,
        ...options.headers
      }
    });

    if (!response.ok) {
      const errorText = await response.text();
      let errorMessage: string;
      try {
        const errorJson = JSON.parse(errorText);
        errorMessage = errorJson.error || errorJson.message || errorText;
      } catch {
        errorMessage = errorText;
      }
      throw new Error(errorMessage);
    }

    // Handle empty responses
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      return response.json();
    }

    return {} as T;
  }
}
